import { render, staticRenderFns } from "./form5_4.vue?vue&type=template&id=5460041f&scoped=true"
import script from "./form5_4.vue?vue&type=script&lang=js"
export * from "./form5_4.vue?vue&type=script&lang=js"
import style0 from "./form5_4.vue?vue&type=style&index=0&id=5460041f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460041f",
  null
  
)

export default component.exports